export default __webpack_public_path__ + "static/media/icons-delete.eacdb3c7.svg";